import React from 'react';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const LastTopUp = ({ amount = '£250.00', detail = '14/06/2026 · Visa •••• 4242' }) => {
  const { translateText } = useTranslation();

  return (
    <div className={styles.statCard} data-testid="walletLastTopUp">
      <div className={styles.statHeader}>
        <span className={styles.statLabel}>
          {translateText('corporateAccounts.wallet.dashboard.lastTopUp.label')}
        </span>
      </div>
      <div className={`${styles.statValue} ${styles.statValueSmall}`}>{amount}</div>
      <div className={`${styles.statSub} ${styles.statSubTight}`}>{detail}</div>
    </div>
  );
};

export default LastTopUp;
